import { render, staticRenderFns } from "./MyCommissions.vue?vue&type=template&id=c20155e0&scoped=true"
import script from "./MyCommissions.vue?vue&type=script&lang=js"
export * from "./MyCommissions.vue?vue&type=script&lang=js"
import style0 from "./MyCommissions.vue?vue&type=style&index=0&id=c20155e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20155e0",
  null
  
)

export default component.exports